class RemoveProductFields {
  constructor() {
    this.iterateLinks();
  }

  iterateLinks() {
    document.addEventListener("click", (e) => {
      if (e.target && e.target.classList.contains("remove-product-fields")) {
        this.handleClick(e.target, e);
        // Dopo la rimozione del prodotto, aggiorna lo stato dei link "Rimuovi Ordine"
        this.updateRemoveProductLinks();
      }
    });
  }

  handleClick(link, e) {
    if (!link || !e) return;
    e.preventDefault();
    let fieldParent = link.closest(".product-details-fields");
    let deleteField = fieldParent ? fieldParent.querySelector('.destroy-product') : null;
    if (deleteField) {
      deleteField.value = 1;
      // Nasconde visivamente il prodotto
      fieldParent.style.display = "none";
    }
  }

  updateRemoveProductLinks() {
    // Trova il container dei prodotti
    const productContainer = document.getElementById("productContainer");

    // Trova tutti i prodotti presenti
    const products = productContainer.querySelectorAll('.product-details-fields:not([style*="display: none"])');

    // Trova i link per rimuovere il prodotto
    const removeProductLinks = document.querySelectorAll('.remove-product-fields');

    // Verifica se ci sono più di un prodotto
    if (products.length >= 2) {
      // Riattiva i link per rimuovere il prodotto
      removeProductLinks.forEach(link => {
        link.classList.remove('disabled');
        link.removeAttribute('disabled');
        link.closest('.remove-product-fields').style.display = "block"; // Mostra visivamente il prodotto
      });
    } else {
      // Disattiva i link per rimuovere il prodotto
      removeProductLinks.forEach(link => {
        link.classList.add('disabled');
        link.setAttribute('disabled', 'disabled');
        link.closest('.remove-product-fields').style.display = "none"; // Nasconde visivamente il prodotto
      });
    }
  }
}

window.addEventListener("turbolinks:load", () => new RemoveProductFields());
